export const colors = {
  orange: "#ff5f30",
  red: "#FF4E40",
  "light-gray": "#f5f5f5",
  "dark-gray": "#4d4d4d",
  "gray-1": "#afafaf",
  "gray-2": "#4d4d4d26",
  "gray-3": "#4d4d4d4d",
  "blue-1": "#009383",
  "blue-2": "#87C9BA",
  "blue-3": "#006B5F",
  "blue-4": "#004740",
  "blue-5": "#E3F2EB",
};
